import { useState, useEffect } from "react";
import HeroSlider from "../components/HeroSlider";
import WhyChooseUs from "../components/WhyChooseUs";
import CTA from "../components/CTA";
import ProductsSection from "../components/ProductsSection";
import { Helmet } from "react-helmet";

export default function Home() {
    const [activeFaq, setActiveFaq] = useState(null);
    const [testimonialIndex, setTestimonialIndex] = useState(0);
    const testimonials = [
        {
            name: "प्रिया शर्मा",
            text: "Shree Balaji Masale ने मेरी रसोई का स्वाद ही बदल दिया है। हल्दी और मिर्च पाउडर की खुशबू मुझे घर के बने मसालों की याद दिलाती है।",
            product: "हल्दी पाउडर",
        },
        {
            name: "नेहा वर्मा",
            text: "Shree Balaji Masale के मसाले वाकई बहुत शुद्ध और असली हैं। स्वाद में साफ़ फर्क महसूस होता है।",
            product: "धनिया पाउडर",
        },
        {
            name: "अनिता पटेल",
            text: "साधारण सब्ज़ी हो या खास पकवान, Shree Balaji Masale हर डिश में जान डाल देता है।",
            product: "लाल मिर्च पाउडर",
        },
        {
            name: "सुनीता रेड्डी",
            text: "अब मेरी रसोई में सिर्फ Shree Balaji Masale ही इस्तेमाल होते हैं।",
            product: "गरम मसाला",
        },
        {
            name: "राकेश सिंह",
            text: "इतनी शुद्धता और क्वालिटी बहुत कम ब्रांड्स में मिलती है।",
            product: "जीरा पाउडर",
        },
    ];
    useEffect(() => {
        const interval = setInterval(() => {
            setTestimonialIndex((prev) =>
                (prev + 1) % testimonials.length
            );
        }, 4000); // ⏱️ 4 seconds auto-slide

        return () => clearInterval(interval);
    }, [testimonials.length]);

    return (
        <>
            <Helmet>
                <title>श्री बालाजी मसाले कुरावर राजगढ़ | शुद्ध भारतीय मसाले</title>

                <meta
                    name="description"
                    content="श्री बालाजी मसाले, कुरावर जिला राजगढ़ मध्य प्रदेश का भरोसेमंद मसाला ब्रांड है जो शुद्ध और उच्च गुणवत्ता वाले मसाले प्रदान करता है।"
                />

                <link rel="canonical" href="https://shribalajimasale.com/" />
            </Helmet>

            <HeroSlider />
            {/* ================= SEO CONTENT WITH ADDRESS ================= */}
            <section className="relative py-12 md:py-16">
                <div className="max-w-7xl mx-auto px-4 md:px-6">

                    <div className="
      grid grid-cols-1 md:grid-cols-2 
      gap-10 md:gap-14 
      items-center
      bg-black/50 
      backdrop-blur-sm 
      rounded-3xl 
      p-6 md:p-12
      shadow-2xl
    ">

                        {/* LEFT CONTENT */}
                        <div>
                            <h1 className="text-2xl md:text-4xl font-bold text-[#ffb3b8] leading-tight">
                                श्री बालाजी मसाले – स्वाद, शुद्धता और भरोसे की पहचान
                            </h1>

                            <p className="mt-4 text-gray-200 text-base md:text-lg leading-relaxed">
                                श्री बालाजी मसाले एक अग्रणी भारतीय मसाला निर्माता है, जो वर्षों से
                                अपने ग्राहकों को उच्च गुणवत्ता वाले मसाले उपलब्ध करा रहा है। हम
                                पारंपरिक भारतीय स्वाद को बनाए रखते हुए आधुनिक तकनीक का उपयोग करते हैं,
                                ताकि हर उत्पाद में शुद्धता और असली खुशबू बनी रहे।
                            </p>

                            <p className="mt-4 text-gray-200 text-base md:text-lg leading-relaxed">
                                हमारे मसाले सीधे चुनिंदा किसानों से प्राप्त कच्चे माल से तैयार किए जाते हैं,
                                जिससे गुणवत्ता और ताजगी सुनिश्चित होती है। हमारे उत्पाद घरों के साथ-साथ
                                होटल, रेस्टोरेंट और थोक व्यापारियों के लिए भी उपयुक्त हैं।
                            </p>

                            {/* ADDRESS */}
                            <div className="mt-6 bg-[#7a0c18]/60 p-4 rounded-xl">
                                <h2 className="text-lg font-semibold text-white">
                                    📍 हमारा पता:
                                </h2>
                                <p className="text-gray-200 mt-2 text-sm md:text-base">
                                    श्री बालाजी मसाले, कुरावर, जिला राजगढ़, मध्य प्रदेश, भारत
                                </p>
                            </div>

                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="flex justify-center h-full">
                            <img
                                src="/images/about/balaji-masale.jpg"
                                alt="श्री बालाजी मसाले उत्पाद"
                                className="rounded-3xl shadow-2xl w-full h-full object-cover max-h-[450px]"
                            />
                        </div>

                    </div>
                </div>
            </section>
            <ProductsSection />
            <main className="relative z-10">

                {/* ================= WHY CHOOSE US ================= */}
                <WhyChooseUs />

                {/* ================= BRAND QUALITY SECTION (HINDI) ================= */}
                <section className="pt-10 pb-6 md:pt-14 md:pb-8">
                    <div className="max-w-7xl mx-auto px-4 md:px-6 flex justify-center">

                        {/* 🔥 GLASS MAIN BOX */}
                        <div
                            className="
        w-full
        max-w-6xl
        bg-black/55
        backdrop-blur-sm
        rounded-3xl
        shadow-2xl
        px-6 md:px-14
        py-10 md:py-12
      "
                        >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-14 items-center">

                                {/* LEFT – CONTENT */}
                                <div>
                                    <h2 className="text-3xl md:text-5xl font-extrabold text-[#ffb3b8] leading-tight">
                                        शुद्ध भारतीय मसालों का <br className="hidden md:block" /> असली स्वाद
                                    </h2>

                                    <h2 className="mt-4 md:mt-5 text-lg md:text-xl text-gray-200 font-medium">
                                        शुद्धता • गुणवत्ता • भरोसे का नाम
                                    </h2>

                                    <p className="mt-5 md:mt-6 text-gray-100 leading-relaxed text-base md:text-lg">
                                        बालाजी मसाले भारतीय रसोई तक असली स्वाद पहुँचाने के लिए प्रतिबद्ध हैं।
                                        हमारे मसाले सावधानीपूर्वक चुने जाते हैं और आधुनिक, स्वच्छ प्रक्रियाओं
                                        द्वारा तैयार किए जाते हैं, ताकि उनकी प्राकृतिक खुशबू, रंग और स्वाद
                                        हमेशा बरकरार रहे।
                                    </p>

                                    <ul className="mt-6 md:mt-8 space-y-3 text-gray-100">
                                        <li className="flex items-center gap-3">
                                            <span className="text-[#ffb3b8] text-lg md:text-xl">✔</span>
                                            चुनिंदा कच्चे मसाले
                                        </li>
                                        <li className="flex items-center gap-3">
                                            <span className="text-[#ffb3b8] text-lg md:text-xl">✔</span>
                                            स्वच्छ एवं आधुनिक निर्माण
                                        </li>
                                        <li className="flex items-center gap-3">
                                            <span className="text-[#ffb3b8] text-lg md:text-xl">✔</span>
                                            पारंपरिक भारतीय स्वाद
                                        </li>
                                        <li className="flex items-center gap-3">
                                            <span className="text-[#ffb3b8] text-lg md:text-xl">✔</span>
                                            भारतीय परिवारों का भरोसा
                                        </li>
                                    </ul>
                                </div>

                                {/* RIGHT – IMAGE */}
                                <div className="relative flex justify-center">
                                    <img
                                        src="/images/home/DSC_2555.jpg"
                                        alt="शुद्ध भारतीय मसाले"
                                        className="rounded-3xl shadow-2xl max-w-full md:max-w-md"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </section>


                {/* ================= RUNNING TAGLINE ================= */}
                <section className="w-full bg-[#7a0c18] overflow-hidden">
                    <div className="marquee-track">
                        {[1, 2, 3].map((_, index) => (
                            <div className="marquee-item" key={index}>
                                🌶️ रिश्ता विश्वास का, वर्षों के साथ का — हमारी 1 चम्मच 3 चम्मच के बराबर
                            </div>
                        ))}
                    </div>

                    <style>
                        {`
        .marquee-track {
            display: flex;
            width: max-content;
            animation: marquee 18s linear infinite;
        }

        .marquee-item {
            white-space: nowrap;
            padding: 14px 40px;
            font-weight: 600;
            font-size: 16px;
            color: white;
        }

        @keyframes marquee {
            from {
                transform: translateX(0);
            }
            to {
                transform: translateX(-50%);
            }
        }
        `}
                    </style>
                </section>

                {/* ================= TESTIMONIALS SECTION ================= */}
                <section className="pt-10 pb-8 md:pt-14 md:pb-10">
                    <div className="max-w-7xl mx-auto px-4 flex justify-center">

                        {/* 🔥 GLASS MAIN BOX */}
                        <div
                            className="
        w-full
        max-w-5xl
        bg-black/55
        backdrop-blur-sm
        rounded-3xl
        shadow-2xl
        px-6 md:px-14
        py-10 md:py-14
        overflow-hidden
      "
                        >
                            {/* Heading */}
                            <div className="mb-12 text-center">
                                <h2 className="text-2xl md:text-5xl font-extrabold text-[#ffb3b8]">
                                    हमारे खुशहाल ग्राहकों की राय
                                </h2>
                            </div>

                            {/* SLIDER */}
                            <div className="overflow-hidden">
                                <div
                                    className="flex transition-transform duration-500 ease-in-out"
                                    style={{
                                        transform: `translateX(-${testimonialIndex * 100}%)`,
                                    }}
                                >
                                    {testimonials.map((item, index) => (
                                        <div key={index} className="min-w-full px-3 md:px-6">
                                            <div className="
                border border-white/20
                rounded-2xl
                p-6 md:p-8
                bg-black/40
                text-center
                max-w-xl
                mx-auto
              ">
                                                <h3 className="text-lg font-bold text-white">
                                                    {item.name}
                                                </h3>

                                                <div className="mt-2 text-[#ffb3b8]">
                                                    ★★★★★
                                                </div>

                                                <p className="mt-4 text-gray-200 leading-relaxed text-base md:text-lg">
                                                    “{item.text}”
                                                </p>

                                                <div className="mt-6 border-t border-white/20 pt-4">
                                                    <p className="font-medium text-[#ffb3b8]">
                                                        {item.product}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* CONTROLS */}
                            <div className="mt-12 flex justify-center gap-6">
                                <button
                                    onClick={() =>
                                        setTestimonialIndex(
                                            (testimonialIndex - 1 + testimonials.length) %
                                            testimonials.length
                                        )
                                    }
                                    className="
            w-11 h-11 md:w-12 md:h-12
            border border-white/40
            rounded-full
            flex items-center justify-center
            text-xl text-white
            hover:bg-[#7a0c18]
            transition
          "
                                >
                                    ‹
                                </button>

                                <button
                                    onClick={() =>
                                        setTestimonialIndex(
                                            (testimonialIndex + 1) % testimonials.length
                                        )
                                    }
                                    className="
            w-11 h-11 md:w-12 md:h-12
            border border-white/40
            rounded-full
            flex items-center justify-center
            text-xl text-white
            hover:bg-[#7a0c18]
            transition
          "
                                >
                                    ›
                                </button>
                            </div>

                        </div>
                    </div>
                </section>





                {/* ================= FAQ SECTION ================= */}
                <section className="pt-10 pb-10 md:pt-14 md:pb-14">
                    <div className="max-w-7xl mx-auto px-6">

                        {/* ✅ MAIN BOX */}
                        <div className="bg-[#fff6df]/95 backdrop-blur rounded-[40px] shadow-2xl px-6 md:px-14 py-10 md:py-14">

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">

                                {/* LEFT SIDE */}
                                <div>
                                    <h2 className="text-4xl md:text-5xl font-extrabold leading-tight text-[#7a0c18]">
                                        Frequently <br /> Asked <br /> Questions
                                    </h2>

                                    <p className="mt-6 text-gray-700 max-w-sm text-lg">
                                        आपके सवालों के जवाब यहाँ मिलेंगे। हमारे उत्पाद,
                                        गुणवत्ता, ऑर्डर और स्टोरेज से जुड़ी सभी जानकारी।
                                    </p>
                                </div>

                                {/* RIGHT SIDE – FAQ */}
                                <div className="space-y-6">
                                    {[
                                        {
                                            q: "क्या Shree Balaji Masale के उत्पाद 100% शुद्ध हैं?",
                                            a: "हाँ, हमारे सभी मसाले 100% शुद्ध और प्राकृतिक कच्चे माल से तैयार किए जाते हैं। इनमें किसी भी प्रकार की मिलावट नहीं होती।",
                                        },
                                        {
                                            q: "आप उत्पाद की गुणवत्ता कैसे सुनिश्चित करते हैं?",
                                            a: "हम चुनिंदा कच्चे मसालों का उपयोग करते हैं और आधुनिक व स्वच्छ प्रक्रिया द्वारा उन्हें तैयार करते हैं।",
                                        },
                                        {
                                            q: "क्या थोक (Bulk) ऑर्डर की सुविधा उपलब्ध है?",
                                            a: "जी हाँ, हम थोक ऑर्डर और डीलरशिप की सुविधा प्रदान करते हैं। अधिक जानकारी के लिए हमसे संपर्क करें।",
                                        },
                                        {
                                            q: "मसालों को ताज़ा रखने के लिए कैसे स्टोर करें?",
                                            a: "मसालों को सूखी और ठंडी जगह पर, एयरटाइट डिब्बे में रखें। नमी से दूर रखें।",
                                        },
                                    ].map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() =>
                                                setActiveFaq(activeFaq === index ? null : index)
                                            }
                                            className={`border rounded-2xl px-6 py-5 cursor-pointer transition bg-white
                            ${activeFaq === index
                                                    ? "border-[#7a0c18] shadow-md"
                                                    : "border-black/20 hover:border-[#7a0c18]/60"
                                                }`}
                                        >
                                            <div className="flex justify-between items-center gap-4">
                                                <h3 className="text-base md:text-lg font-medium text-black">
                                                    {item.q}
                                                </h3>
                                                <span className="text-2xl font-bold text-[#7a0c18]">
                                                    {activeFaq === index ? "−" : "+"}
                                                </span>
                                            </div>

                                            {activeFaq === index && (
                                                <p className="mt-4 text-gray-700 leading-relaxed text-base md:text-lg">
                                                    {item.a}
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>
                </section>



                {/* ================= CALL TO ACTION ================= */}
                <CTA />
            </main>
        </>
    );
}
